<script setup lang="ts">
import type { RouteRecordName } from 'vue-router';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ActionButton from '@/components/buttons/ActionButton.vue';
import useMeQuery from '@/api/queries/me/useMeQuery';
import { MixpanelInstance } from '@/plugins/mixpanel/mixpanel';
import { useGlobalStore } from '@/stores/global';

const router = useRouter();
const route = useRoute();
const globalStore = useGlobalStore();
const reportUrl = computed(() => globalStore.apps_urls.report_manager);
const me = useMeQuery();

const { isBrainDone, isDriveDone, isShapeDone } = useMeQuery();

const hasAllAssessmentsDone = computed(
  () => isBrainDone.value && isDriveDone.value && isShapeDone.value,
);

function goBack() {
  router.push({ name: route.name as RouteRecordName });
}

function trackMixpanel() {
  if (!hasAllAssessmentsDone.value) return;
  MixpanelInstance.track('personal-report_download', {
    user_uuid: me.auth.value?.uuid,
    email: me.auth.value?.email,
  });
}
</script>

<template>
  <footer class="p-5 bg-white">
    <div class="flex gap-6 justify-between md:justify-end w-full">
      <ActionButton cancel @click="goBack">
        {{ $t('general.cancel') }}
      </ActionButton>

      <a
        v-if="$route.query.share === 'synthesis'"
        rel="noopener noreferrer"
        target="_blank"
        :href="
          hasAllAssessmentsDone
            ? `${reportUrl}/report/personal_synthesis/${me.auth.value?.uuid}`
            : undefined
        "
        class="bg-af-pink-500 text-white grid place-content-center px-5 py-2 rounded-full text-sm cursor-default"
        :class="{ 'opacity-50': !hasAllAssessmentsDone, 'cursor-pointer': hasAllAssessmentsDone }"
        @click="trackMixpanel"
      >
        {{ $t('candidate_account.share.panel.report.cta') }}
      </a>
    </div>
  </footer>
</template>
